import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Form, Button, Dropdown } from 'react-bootstrap';
import { FaCheckCircle, FaFileAlt, FaBold, FaItalic, FaListUl, FaListOl, FaUnderline, FaSubscript, FaSuperscript, FaSyncAlt } from 'react-icons/fa';
import Navbar from "../../Pages/Navbar/EmployerNavbar";
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import BaseUrl from '../../ApiServices/BaseUrl';
import './JobDescription.css';
import { CLEANING_MAINTENANCE_POSITIONS, CONSTRUCTION_POSITIONS, HOSPITALITY_POSITIONS, RETAIL_SALES_POSITIONS, SOFTWARE_IT_POSITIONS, DRIVER_POSITIONS } from '../../../Constants/dropdownOptions';

const JobDescriptionForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem('user'));
  const userId = user?.id;
  const temporaryId = location.state?.temporaryId;

  const [loading, setLoading] = useState(true);
  const [workCountry, setWorkCountry] = useState('');
  // Commenting out dynamic job positions state
  // const [jobPositions, setJobPositions] = useState([]);
  const [isInitialized, setIsInitialized] = useState(false);

  // State for dropdowns
  const [firstDropdownSearch, setFirstDropdownSearch] = useState('');
  const [secondDropdownSearch, setSecondDropdownSearch] = useState('');
  const [showFirstDropdown, setShowFirstDropdown] = useState(false);
  const [showSecondDropdown, setShowSecondDropdown] = useState(false);

  // Static country options
  const countryOptions = [
    "UAE Family Looking For",
    "Turkey Family Looking For",
    "Germany Family looking for",
    "Germany Hospital looking for",
    "UK looking for",
    "Ireland looking for",
    "UK company looking for",
    "Uk Hospital looking for",
    "Uk faimly looking for",
    "Gemany looking for",
    "Croatia looking for",
    "European country looking for",
    "Turkey looking for",
    "Dubai Looking for",
    "Qatar Looking for",
    "Canada looking for",
    "Crotia Family Looking For",
    "Crotia Company Looking For",
    "Australia looking for",
    "New Zealand looking for",
    "United States looking for",
    "Dubai Family Looking For",
    "Omani Family Looking For",
    "Russian Family Looking For",
    "Saudi Family Looking For",
    "Qatari Family Looking For",
    "Kuwaiti Family Looking For",
    "Bahraini Family Looking For",
    "Jordanian Family Looking For",
    "Lebanese Family Looking For",
    "Singaporean Family Looking For",
    "Hong Kong Family Looking For",
    "Malaysian Family Looking For",
    "Taiwanese Family Looking For",
    "Japanese Family Looking For",
    "South Korean Family Looking For",
    "Bruneian Family Looking For",
    "US Family Looking For",
    "European Family Looking For",
    "Looking For",
    // New options added
    "Dubai looking for",
    "Abu Dhabi looking for",
    "Qatar looking for",
    "UAE looking for",
    "Saudi looking for",
    "Oman looking for",
    "Kuwait looking for",
    "Bahrain looking for",
    "Singapore looking for",
    "Malaysia looking for",
    "Taiwan looking for",
    "South Korea looking for",
    "Brunei looking for",
    "Japan looking for",
    "Hong Kong looking for",
    "India looking for",
    "Germany looking for",
    "UK looking for",
    "Ireland looking for",
    "Canada looking for",
    "Australia looking for",
    "New Zealand looking for",
    "Poland Looking for",
    "Poland  company looking for",
    "Poland faimly looking for",
    "Cyprus looking for",
    "Cypriot Family Looking For",
    // All countries
    "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda", "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia", "Cameroon", "Canada", "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros", "Congo", "Costa Rica", "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia", "Fiji", "Finland", "France", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Greece", "Grenada", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Kosovo", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Korea", "North Macedonia", "Norway", "Oman", "Pakistan", "Palau", "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Qatar", "Romania", "Russia", "Rwanda", "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Korea", "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay", "Uzbekistan", "Vanuatu", "Vatican City", "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe"
    ,
    "with Qatar License",
    "with GCC License",
    "with UAE License",
    "with Saudi License",
    "with Kuwait License",
    "with Oman License",
    "with Bahrain License",
    "with India License",
    "with Nepal License",
    "with Pakistan License",
    "with Bangladesh License",
    "with Sri Lanka License",
    "with Philippines License",
    "with Indonesia License",
    "with Malaysia License",
    "with Singapore License",
    "with Hong Kong License",
    "with Thailand License",
    "with Vietnam License",
    "with China License",
    "with Japan License",
    "with South Korea License",
    "with Turkey License",
    "with EU License",
    "with UK License",
    "with Germany License",
    "with France License",
    "with Italy License",
    "with Spain License",
    "with Poland License",
    "with Romania License",
    "with Croatia License",
    "with Greece License",
    "with Portugal License"
  ];

  // Static job positions array
  const staticJobPositions = [
    "Home Driver",
    "Home Cook",
    "Home Care Nurse",
    "Home Caregiver",
    "Company Driver",
    "Light Driver",
    "Motorbike Driver", "Domestic Helper", "Maid", "Driver", "Driver (Company / House)", "Lady Driver", "Personal Driver", "Bus Driver", "Plumber", "Taxi Driver", "Operator", "Electrician", "Welder", "Cook", "Cook (Company / House)", "Nanny", "Nurse", "Houseboy", "Tailor", "Teacher",
    "Trainer", "Beautician", "Gardener", "Farmar", "Butler", "Housekeeper", "Laundry Worker", "Personal Assistant",
    "Caregiver", "Elder Care", "Pet Sitter", "House Manager",
    "Cleaner", "Maintenance Worker", "Baby Sitter", "Tutor", "Chauffeur",
    "Housemaid", "Kitchen Staff", "Dining Room Attendant", "Personal Chef",
    "Event Coordinator", "Household Administrator", "Domestic Assistant", "Hospital Nurse", "Physiotherapy",
    "Hospital Doctor",
    "Resident Doctor",
    "Heavy Driver",
    "Bike Driver",
    "JCB Operator",
    "Bulldozer Operator",
    "Excavator Operator",
    "Loader Operator",
    "Skid Steer Loader Operator",
    "Grader Operator",
    "Trench Excavator / Trencher Operator",
    "Backhoe Operator",
    "Dragline Operator",
    "Scraper Operator",
    "Crane Operator",
    "Telehandler Operator",
    "Reach Stacker Operator",
    "Boom Lift / Cherry Picker Operator",
    "Container Handler Operator",
    "Road Roller Operator",
    "Asphalt Paver Operator",
    "Bitumen Sprayer Operator",
    "Concrete Paver Operator",
    "Soil Stabilizer Operator",
    "Drilling Machine / Drill Rig Operator",
    "Rock Breaker / Hydraulic Hammer Operator",
    "Loader-Dumper Operator",
    "Dump Truck Operator",
    "Stone Crusher Operator",
    "Grizzly Feeder / Conveyor Operator",
    "Tractor Operator",
    "Harvester / Combine Operator",
    "Dozer / Land Leveling Operator",
    "Tower Crane Operator",
    "Mobile Crane Operator",
    "Crawler Crane Operator",
    "Piling Machine Operator",
    "Concrete Mixer Truck Operator",
    "Concrete Pump Operator",
    "Compactor Operator",
    "Pipe Layer Operator",
    "Forklift / Warehouse Equipment Operator",
    "Boom Truck / Loader Crane Operator",
    "Road Sweeper Operator",
    "Water Tanker / Firefighting Vehicle Operator",
    "Excavator Mounted Drill Operator",
    "Heavy Truck / Tip Truck Operator",
    "Loader Excavator Operator",
    "Teleporter Crane Operator",
    "Material Handler / Port Crane Operator",
    "Hydraulic Excavator Operator",
    "Multi-Functional Heavy M",
    // New options - Workers
    "Workers",
    "Skilled Workers",
    "Construction Workers",
    "Skilled Construction Workers",
    "Mason",
    "Carpenter",
    "Steel Fixer",
    "Painter",
    "AC Technician", "HVAC Technician", "Chiller Technician",
    "Lathe & Milling Machine", "Lathe Machine Operator", "Milling Machine Operator",
    "Heavy Equipment Operator",
    "Scaffolder",
    // Hospital Staff (additional)
    "Healthcare Assistants",
    "Doctors",
    "Lab Technicians",
    "Physiotherapy",
    "Physiotherapists",
    "Elderly Care Workers",
    // Hospitality Workers
    ...HOSPITALITY_POSITIONS,
    ...SOFTWARE_IT_POSITIONS,
    ...CONSTRUCTION_POSITIONS,
    ...RETAIL_SALES_POSITIONS,
    ...CLEANING_MAINTENANCE_POSITIONS,
    // Factory Workers
    "Factory Workers",
    "Production Workers",
    "Warehouse Workers",
    "Packing Staff",
    "Machine Operators",
    "Assembly Line Workers",
    "Forklift Operators",
    // Drivers (additional)
    "Delivery Drivers",
    "Truck Drivers",
    "Logistics Staff",
    // Farm Workers
    "Farm Workers",
    "Fruit Pickers",
    "Dairy Workers",
    "Poultry Workers",
    "Greenhouse Workers",
    // Additional Care roles
    "Caretakers",
    "Private Drivers",
    // CNC & Machine Operations
    "CNC Machinist",
    "CNC Programmer",
    "CNC Milling Programmer",
    "CNC Turning Programmer",
    "CNC 5-Axis Programmer",
    "CNC CAD/CAM Programmer",
    "CNC Setter",
    "CNC Setup Operator",
    "CNC Quality Inspector (CMM)",
    "CNC Maintenance Technician",
    "CNC Tool Room Technician",
    "CNC Production Technician",
    "CNC Machine Operator",
    "CNC Milling Operator",
    "CNC Turning Operator",
    "CNC Lathe Operator",
    "CNC VMC Operator",
    "CNC HMC Operator",
    "CNC Operator",
    "Machine Operator",
    "Assembly Line Worker",
    "Production Worker",
    // Welding
    "MIG Welder",
    "TIG Welder",
    "Industrial Welder",
    "Fabricator",
    "Steel Structure Welder",
    // Mechanics
    "Heavy Truck Mechanic",
    "Diesel Mechanic",
    "Auto Mechanic",
    "Bus Mechanic",
    "Vehicle Technician",
    // Electrical & Automation
    "Industrial Electrician",
    "Maintenance Electrician",
    "Panel Electrician",
    "Maintenance Technician",
    "Electrical Technician",
    "PLC Technician",
    "Automation Technician",
    // Construction
    "Construction Worker",
    // Warehouse & Logistics
    "Warehouse Worker",
    "Forklift Operator",
    "Picker & Packer",
    "Delivery Van Driver",
    "Logistics Assistant",
    // Heavy Drivers
    "Heavy Truck Driver (CE)",
    "Trailer Driver",
    // Hospitality
    "Chef",
    "Kitchen Assistant",
    "Hotel Housekeeping",
    // Healthcare
    "Medical Technician",
    // Additional specialized roles
    "Instrument Technician",
    "Mechanical Maintenance Technician",
    "Heavy Equipment Mechanic",
    "6G Welder",
    "Structural Welder",
    "Shipyard Welder",
    "FCAW Welder (Shipyard)",
    "MIG/MAG Welder (Shipyard)",
    "TIG Welder (Shipyard)",
    "6G Pipe Welder (Shipyard)",
    "Heavy Trailer Driver",
    "Fuel Tanker Driver",
    "Ready-Mix Driver",
    "Registered Nurse",
    "Professional Chef",

    // New Roles added
    "Full-Time Helper Needed",
    "Household Helper Required",
    "Family Hiring Home Helper",
    "Helper Job Available",
    "Immediate Hiring Helper",
    "Live-In Helper Needed",
    "Part-Time Helper Required",
    "Helper Wanted for Family",
    "Home Helper Needed",
    "House Helper Required",
    "Cleaning Helper Needed",
    "Housekeeping Helper Required",
    "Kitchen Helper Needed",
    "Cook Helper Required",
    "Babysitter Helper Needed",
    "Nanny & Helper Required",
    "Elderly Care Helper Needed",
    "Caregiver Helper Required",
    "Dog Helper Needed",
    "Pet Care Helper Required",
    "Dog Caretaker Needed",
    "Dog Walker Needed",
    "Pet Assistant Needed",
    "Cat Helper Needed",
    "Cat Care Helper Required",
    "Cat Caretaker Needed",
    "Cat Sitter Needed",
    "Cat Assistant Required",
    "Horse Helper Needed",
    "Horse Care Helper Required",
    "Horse Caretaker Needed",
    "Horse Groom Needed",
    "Stable Helper Required",
    "Horse Assistant Needed",
    "Horse Handler Required",
    "Flower Helper Needed",
    "Flower Care Helper Required",
    "Garden Helper Needed",
    "Flower & Garden Helper Required",
    "Gardener Helper Needed",
    "Plant Care Helper Required",
    "Nursery Helper Needed",
    "Landscape Helper Required",
    "Flower Decorator Needed",
    "Flower Decoration Expert Required",
    "Event Flower Decorator Needed",
    "Wedding Flower Decorator Required",
    "Floral Decorator Needed",
    "Stage Flower Decorator Required",
    "Experienced Flower Decorator Needed",
    "Flower Arrangement Specialist Required",
    "Hotel Manager Needed",
    "Assistant Hotel Manager Required",
    "Front Office Executive Needed",
    "Receptionist Required",
    "Guest Relations Executive Needed",
    "Housekeeping Staff Needed",
    "Room Attendant Required",
    "Housekeeping Supervisor Needed",
    "Laundry Staff Required",
    "Public Area Cleaner Needed",
    "Chef Needed",
    "Sous Chef Required",
    "Cook Required",
    "Commis Chef Needed",
    "Steward Needed",
    "Dishwasher Required",
    "Waiter Needed",
    "Waitress Required",
    "Service Crew Needed",
    "Restaurant Captain Required",
    "Banquet Staff Needed",
    "Barista Needed",
    "Bartender Required",
    "Juice Maker Needed",
    "Bellboy Needed",
    "Porter Required",
    "Concierge Needed",
    "Security Guard Needed",
    "Hotel Driver Required",
    "Valet Driver Needed",
    "Maintenance Technician Needed",
    "Electrician Required",
    "Plumber Needed",
    "AC Technician Required",
    "Spa Therapist Needed",
    "Massage Therapist Required",
    "Salon Staff Needed",
    "Professional Massage Therapist Required",
    "Experienced Massager Needed",
    "Male Massage Therapist Needed",
    "Female Massage Therapist Required",
    "Spa Massage Therapist Needed",
    "Hotel Massage Therapist Required",
    "Home Service Massager Needed",
    "Thai Massage Therapist Needed",
    "Arabic Massage Therapist Required",
    "Deep Tissue Massage Therapist Needed",
    "Relaxation Massage Therapist Needed",
    "Sports Massage Therapist Required",
    "Ayurvedic Massage Therapist Needed",
    "Foot Massage Therapist Required",
    "Body Massage Therapist Needed",
    "Spa Assistant Needed",
    "Massage Assistant Required",
    "VIP Family Hiring Helper",
    "Royal Family Hiring Helper",
    "Experienced Helper Needed",
    "Urgent Hiring Household Helper",
    "Premium Household Helper Needed",
    "Luxury Family Hiring Helper",
    "Elite Family Hiring Helper",
    "Private Family Hiring Helper",
    "VIP Household Helper Required",
    "Royal Household Helper Needed",
    "Professional Household Helper Required",
    "Trusted Helper Needed",
    "Well-Trained Helper Required",
    "Live-In VIP Helper Needed",
    "Senior Household Helper Needed",
    "Immediate Joining Household Helper",
    "Full-Time VIP Helper Needed",
    "Experienced Live-In Helper Required",
    "Household Assistant Needed",
    "Personal Helper Required"
  ];

  const [formData, setFormData] = useState({
    job_title: '',
    job_category: '',
    job_description: ''
  });

  const wordCount = formData.job_description.split(' ').filter(word => word.trim().length > 0).length;

  // Refs
  const editorRef = useRef(null);
  const lastCursorPosition = useRef(null);
  const isDataLoaded = useRef(false);
  const isSaving = useRef(false);
  const [profileData, setProfileData] = useState(null);
  const [isGenerating, setIsGenerating] = useState(false);
  const [currentTemplateIndex, setCurrentTemplateIndex] = useState(0);

  // Helper to format lists
  const formatList = (items) => {
    if (!items || !items.length) return '';
    if (items.length === 1) return items[0];
    if (items.length === 2) return `${items[0]} and ${items[1]}`;
    return items.slice(0, -1).join(', ') + ', and ' + items[items.length - 1];
  };

  // Template Generation Logic
  const generateDescription = (index, dataOverride = null, categoryOverride = null) => {
    const dataToUse = dataOverride || profileData;
    if (!dataToUse) return '';

    const {
      looking_worker_for,
      job_category,
      adults,
      children,
      type_of_house,
      main_skills,
      offer_for_selected_candidates,
      organization_name
    } = dataToUse;

    const category = categoryOverride || job_category || formData.job_category || 'worker';
    const skills = formatList(typeof main_skills === 'string' ? JSON.parse(main_skills || '[]') : main_skills);
    const offers = formatList(typeof offer_for_selected_candidates === 'string' ? JSON.parse(offer_for_selected_candidates || '[]') : offer_for_selected_candidates);

    if (looking_worker_for === 'For my family') {
      const familyTemplates = [
        () => `We are looking for a reliable and experienced ${category} for our family. Our household consists of ${adults || 0} adults and ${children || 0} children living in a ${type_of_house || 'house'}. The ideal candidate should be punctual, trustworthy, and skilled in ${skills || 'household duties'}. We offer ${offers || 'competitive benefits'}. Immediate joining preferred.`,
        () => `Our family is seeking a professional ${category} to assist with our daily needs. We live in a ${type_of_house || 'comfortable home'} with ${adults || 0} adults and ${children || 0} children. We require someone with good knowledge of ${skills || 'various tasks'}. In return, we provide ${offers || 'a good working environment'}. Please contact us if interested.`,
        () => `Seeking a dedicated ${category} for a family household of ${adults || 0} adults and ${children || 0} children. Responsibilities include general ${category} duties and ${skills || 'daily chores'}. The house is a ${type_of_house || 'residence'} where we value politeness and honesty. Benefits include ${offers || 'standard perks'}. Clean record required.`,
        () => `We urgently need an experienced ${category} to join our family. Our home is a ${type_of_house || 'well-kept residence'} accommodating ${adults || 0} adults and ${children || 0} children. Essential skills include ${skills || 'general responsibilities'}. We are looking for a respectful and hardworking individual. We offer ${offers || 'fair compensation'}.`,
        () => `A family of ${adults || 0} adults and ${children || 0} children is looking for a trustworthy ${category}. We reside in a ${type_of_house || 'house'} and need assistance with ${skills || 'daily tasks'}. The candidate must be reliable, well-mannered, and proactive. Included benefits are ${offers || 'standard allowances'}. Contact us to apply.`
      ];
      return familyTemplates[index % familyTemplates.length]();
    } else {
      const companyTemplates = [
        () => `${organization_name || 'Our company'} is looking for a responsible and experienced ${category}. The candidate must be professional, punctual, and have a good understanding of ${skills || 'required tasks'}. Duties involve company-related errands and staff support. We offer ${offers || 'standard company benefits'}. Immediate joining preferred.`,
        () => `We are hiring a professional ${category} for ${organization_name || 'our organization'}. Ideal candidates should be trustworthy with a clean record and expertise in ${skills || 'relevant areas'}. Responsibilities include daily operations and professional support. We provide ${offers || 'competitive terms'}. Interested candidates may contact us for more details.`,
        () => `${organization_name || 'The company'} is seeking a dedicated ${category} to join our team. We require someone well-mannered and punctual with skills in ${skills || 'professional duties'}. The role involves supporting our staff and handling specialized tasks. Benefits include ${offers || 'comprehensive package'}. Professional experience is a must.`,
        () => `${organization_name || 'Our growing business'} is searching for a skilled ${category}. The role demands proficiency in ${skills || 'industry duties'} and a strong work ethic. Candidates must be reliable and adaptable to a professional environment. We are pleased to offer ${offers || 'attractive benefits'}. Apply now for immediate consideration.`,
        () => `An excellent opportunity for an experienced ${category} at ${organization_name || 'our company'}. We value dedication and expect strong capabilities in ${skills || 'the relevant field'}. The position requires a high level of responsibility and teamwork. Selected candidates will receive ${offers || 'competitive pay and benefits'}. We look forward to your application.`
      ];
      return companyTemplates[index % companyTemplates.length]();
    }
  };

  const handleChangeDescription = () => {
    if (!profileData) return;

    setIsGenerating(true);
    const nextIndex = (currentTemplateIndex + 1) % 5;
    setCurrentTemplateIndex(nextIndex);

    const generatedText = generateDescription(nextIndex);

    setFormData(prev => ({
      ...prev,
      job_description: generatedText
    }));

    if (editorRef.current) {
      editorRef.current.innerHTML = plainTextToHtml(generatedText);
    }

    setTimeout(() => setIsGenerating(false), 300);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Commenting out dynamic fetching of job positions
  /*
  // Fetch job positions first
  useEffect(() => {
    const fetchJobPositions = async () => {
      try {
        const response = await fetch(`${BaseUrl}/api/jobposition/`);
        if (response.ok) {
          const data = await response.json();
          setJobPositions(data);
        } else {
          throw new Error('Failed to fetch job positions');
        }
      } catch (err) {
        console.error('Error fetching job positions:', err);
      }
    };

    fetchJobPositions();
  }, []);
  */

  // Fetch saved data after job positions are loaded
  useEffect(() => {
    // Using static positions instead of dynamic fetch check
    if (userId && temporaryId && !isDataLoaded.current) {
      fetchSavedData();
    }
  }, [userId, temporaryId]);

  // Save cursor position
  const saveCursorPosition = () => {
    if (!editorRef.current) return;

    const selection = window.getSelection();
    if (selection.rangeCount > 0) {
      const range = selection.getRangeAt(0);
      const preCaretRange = range.cloneRange();
      preCaretRange.selectNodeContents(editorRef.current);
      preCaretRange.setEnd(range.endContainer, range.endOffset);
      lastCursorPosition.current = preCaretRange.toString().length;
    }
  };

  // Restore cursor position
  const restoreCursorPosition = () => {
    if (!editorRef.current || lastCursorPosition.current === null) return;

    try {
      const selection = window.getSelection();
      selection.removeAllRanges();

      // Create a new range
      const range = document.createRange();
      let charIndex = 0;
      const nodeStack = [editorRef.current];
      let node = null;
      let foundStart = false;

      while (node = nodeStack.pop()) {
        if (node.nodeType === 3) { // Text node
          const nextCharIndex = charIndex + node.length;
          if (!foundStart && lastCursorPosition.current >= charIndex && lastCursorPosition.current <= nextCharIndex) {
            range.setStart(node, lastCursorPosition.current - charIndex);
            range.setEnd(node, lastCursorPosition.current - charIndex);
            foundStart = true;
            break;
          }
          charIndex = nextCharIndex;
        } else {
          // For element nodes, push children in reverse order
          const children = node.childNodes;
          for (let i = children.length - 1; i >= 0; i--) {
            nodeStack.push(children[i]);
          }
        }
      }

      if (foundStart) {
        selection.addRange(range);
        editorRef.current.focus();
      }
    } catch (error) {
      console.error('Error restoring cursor position:', error);
    }
  };

  // Convert HTML to plain text for storage
  const htmlToPlainText = (html) => {
    if (!html) return '';

    // Create a temporary div
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    // Handle lists
    tempDiv.querySelectorAll('ul, ol').forEach(list => {
      const listType = list.tagName.toLowerCase();
      const items = list.querySelectorAll('li');
      let listText = '';

      items.forEach((item, index) => {
        if (listType === 'ol') {
          listText += `${index + 1}. ${item.textContent}\n`;
        } else {
          listText += `• ${item.textContent}\n`;
        }
      });

      const textNode = document.createTextNode(listText);
      list.parentNode.replaceChild(textNode, list);
    });

    // Convert br tags to newlines
    tempDiv.querySelectorAll('br').forEach(br => {
      br.parentNode.replaceChild(document.createTextNode('\n'), br);
    });

    // Get text content
    let text = tempDiv.textContent || tempDiv.innerText || '';

    // Clean up multiple spaces and trim
    text = text.replace(/\s+/g, ' ').trim();

    return text;
  };

  // Convert plain text to HTML for display in editor
  const plainTextToHtml = (text) => {
    if (!text) return '';

    // Escape HTML special characters
    const escapedText = text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');

    // Convert newlines to br tags
    const withLineBreaks = escapedText.replace(/\n/g, '<br>');

    // Convert bullet points and numbered lists
    const lines = withLineBreaks.split('<br>');
    let inList = false;
    let listType = '';
    let html = '';

    for (let line of lines) {
      line = line.trim();

      // Check for bullet points
      if (line.startsWith('• ') || line.startsWith('* ')) {
        const content = line.substring(2);
        if (!inList || listType !== 'ul') {
          if (inList) html += `</${listType}>`;
          html += '<ul>';
          inList = true;
          listType = 'ul';
        }
        html += `<li>${content}</li>`;
      }
      // Check for numbered lists (1., 2., etc.)
      else if (/^\d+\.\s/.test(line)) {
        const content = line.replace(/^\d+\.\s/, '');
        if (!inList || listType !== 'ol') {
          if (inList) html += `</${listType}>`;
          html += '<ol>';
          inList = true;
          listType = 'ol';
        }
        html += `<li>${content}</li>`;
      }
      else {
        if (inList) {
          html += `</${listType}>`;
          inList = false;
          listType = '';
        }
        html += `${line}<br>`;
      }
    }

    if (inList) {
      html += `</${listType}>`;
    }

    return html;
  };

  const getJobCategoryOptions = () => {
    // Using static positions instead of dynamic data
    return Array.from(new Set([...DRIVER_POSITIONS, ...staticJobPositions]));

    // Commenting out dynamic job position processing
    /*
    const positions = jobPositions.map((position) => position.position).filter(Boolean);
    let driverCount = 0;
    const normalized = positions.map((position) => {
      if (position.toLowerCase() === 'driver') {
        driverCount += 1;
        return driverCount === 2 ? 'Lady Driver' : 'Driver';
      }
      return position;
    });

    if (!normalized.some((position) => position.toLowerCase() === 'domestic worker')) {
      normalized.push('Domestic Worker');
    }

    return normalized;
    */
  };

  const fetchSavedData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${BaseUrl}/api/employer?temporary_id=${temporaryId}&user_id=${userId}`);
      const data = response.data;

      const workCountry = data.country || '';
      setWorkCountry(workCountry);

      const fullJobTitle = data.job_title || '';
      let jobTitleWithoutCountry = fullJobTitle;
      let jobCategory = data.job_category || '';

      // Auto-fill job_category from domestic_worker_category if not already set
      if (!jobCategory && data.domestic_worker_category) {
        jobCategory = data.domestic_worker_category;
      }

      // Try to extract job category from the full title
      if (fullJobTitle) {
        // First, try to find a matching country prefix
        for (const countryOption of countryOptions) {
          if (fullJobTitle.startsWith(countryOption)) {
            jobTitleWithoutCountry = countryOption;
            jobCategory = fullJobTitle.replace(countryOption, '').trim();
            break;
          }
        }

        // If no country prefix found, try to find a job position
        if (!jobCategory || jobTitleWithoutCountry === fullJobTitle) {
          const categoryOptions = getJobCategoryOptions();
          for (const position of categoryOptions) {
            if (fullJobTitle.includes(position)) {
              jobCategory = position;
              jobTitleWithoutCountry = fullJobTitle.replace(jobCategory, '').trim();
              break;
            }
          }
        }

        // If still no category, use the full title as job title
        if (!jobCategory || jobTitleWithoutCountry === fullJobTitle) {
          jobTitleWithoutCountry = fullJobTitle;
          jobCategory = '';
        }
      }

      // Handle job description
      let jobDescription = data.job_description || '';

      // If description contains HTML, convert to plain text
      if (jobDescription && /<[a-z][\s\S]*>/i.test(jobDescription)) {
        jobDescription = htmlToPlainText(jobDescription);
      }

      if (!jobDescription) {
        jobDescription = generateDescription(0, data, jobCategory);
      }

      // Update form data
      setFormData({
        job_title: jobTitleWithoutCountry,
        job_category: jobCategory,
        job_description: jobDescription
      });

      // Store profile data for auto-fill
      setProfileData(data);

      // Update editor content
      setTimeout(() => {
        if (editorRef.current) {
          editorRef.current.innerHTML = plainTextToHtml(jobDescription);
        }
      }, 100);

      isDataLoaded.current = true;
    } catch (error) {
      console.error('Error fetching saved data:', error);
      // Don't show error if it's a 404 (no data yet)
      if (error.response && error.response.status !== 404) {
        Swal.fire('Error', 'Failed to fetch job description data', 'error');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === 'job_title') {
      if (value.length <= 40) {
        setFormData(prev => ({ ...prev, [name]: value }));
      }
    }
  };

  const handleSelectFirstDropdown = (value) => {
    setFormData(prev => ({ ...prev, job_title: value }));
    setShowFirstDropdown(false);
    setFirstDropdownSearch('');
  };

  const handleSelectSecondDropdown = (value) => {
    setFormData(prev => ({ ...prev, job_category: value }));
    setShowSecondDropdown(false);
    setSecondDropdownSearch('');
  };

  // Filter first dropdown options based on search
  const filteredFirstOptions = countryOptions.filter(option =>
    option.toLowerCase().includes(firstDropdownSearch.toLowerCase())
  );

  // Filter second dropdown options based on search
  const jobCategoryOptions = getJobCategoryOptions();
  const filteredSecondOptions = jobCategoryOptions.filter((position) =>
    position.toLowerCase().includes(secondDropdownSearch.toLowerCase())
  );

  const handleEditorInput = (e) => {
    saveCursorPosition();

    // Get the current HTML content
    const htmlContent = e.currentTarget.innerHTML;

    // Convert to plain text for storage
    const plainTextContent = htmlToPlainText(htmlContent);

    // Update form state
    setFormData(prev => ({
      ...prev,
      job_description: plainTextContent
    }));

    // Restore cursor position after a brief delay
    setTimeout(() => {
      restoreCursorPosition();
    }, 10);
  };

  const applyFormat = (command, value = null) => {
    saveCursorPosition();

    // Focus the editor
    editorRef.current.focus();

    // Apply the command
    document.execCommand(command, false, value);

    // Get updated content
    const htmlContent = editorRef.current.innerHTML;
    const plainTextContent = htmlToPlainText(htmlContent);

    // Update form data
    setFormData(prev => ({
      ...prev,
      job_description: plainTextContent
    }));

    // Restore cursor
    setTimeout(() => {
      restoreCursorPosition();
    }, 10);
  };

  // Get the full job title with both dropdown selections
  const getFullJobTitle = () => {
    const jobTitle = formData.job_title;
    const jobCategory = formData.job_category;

    if (!jobTitle && !jobCategory) return '';
    if (!jobTitle) return jobCategory;
    if (!jobCategory) return jobTitle;

    // Check if job_title contains "looking for" (case insensitive)
    if (jobTitle.toLowerCase().includes('looking for')) {
      return `${jobTitle} ${jobCategory}`;
    } else if (jobTitle.toLowerCase().startsWith('with ')) {
      return `${jobCategory} ${jobTitle}`;
    } else {
      // Plain country selected, format as: Job Category - Country
      return `${jobCategory} - ${jobTitle}`;
    }
  };

  // Get character count for display
  const getCharacterCount = () => {
    const fullTitle = getFullJobTitle();
    return fullTitle.length;
  };

  const handleSubmit = async (action) => {
    if (isSaving.current) return; // Prevent multiple saves

    if (!userId || !temporaryId) {
      Swal.fire('Error', 'User not authenticated or missing temporary ID', 'error');
      return;
    }

    if (action !== 'back') {
      const fullJobTitle = getFullJobTitle();

      if (!formData.job_title || !formData.job_category) {
        Swal.fire('Error', 'Please select both country and job category', 'error');
        return;
      }

      // Get word count from plain text
      const wordCount = formData.job_description.split(' ').filter(word => word.length > 0).length;

      if (!formData.job_description || wordCount < 20 || wordCount > 60) {
        Swal.fire(
          'Error',
          `Job description must be between 20 and 60 words (currently ${wordCount} words)`,
          'error'
        );
        return;
      }
    }

    try {
      isSaving.current = true;
      const fullJobTitle = getFullJobTitle();

      const payload = {
        temporary_id: temporaryId,
        user_id: userId,
        job_title: fullJobTitle,
        job_description: formData.job_description,
        job_category: formData.job_category
      };

      await axios.post(`${BaseUrl}/api/employer`, payload);

      if (action === 'next') {
        Swal.fire('Success!', 'Job description saved successfully!', 'success');
        window.scrollTo(0, 0);
        navigate('/addprofilephoto', { state: { userId, temporaryId } });
      } else if (action === 'save') {
        Swal.fire('Success!', 'Data saved successfully!', 'success');
      }
    } catch (error) {
      console.error('Error saving data:', error);

      const response = error.response;
      if (response && response.status === 402 && response.data.reason === 'insufficient_wallet') {
        Swal.fire({
          title: 'Insufficient Balance',
          html: `Your wallet balance is <b>${response.data.balance}</b>. You need <b>${response.data.required}</b> to post this job. <br/><br/>Please top up your wallet.`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Top Up Wallet',
          cancelButtonText: 'Cancel'
        }).then((result) => {
          if (result.isConfirmed) {
            navigate('/employer/subscriptionplans');
          }
        });
      } else if (response && response.status === 429 && response.data.reason === 'limit_reached') {
        Swal.fire({
          title: 'Limit Reached',
          text: response.data.error,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Upgrade Plan',
          cancelButtonText: 'Cancel'
        }).then((result) => {
          if (result.isConfirmed) {
            navigate('/employer/subscriptionplans');
          }
        });
      } else if (response && response.status === 403) {
        Swal.fire({
          title: 'Subscription Required',
          text: response.data.error || 'You need an active subscription with job posting features to post a job.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'View Plans',
          cancelButtonText: 'Cancel'
        }).then((result) => {
          if (result.isConfirmed) {
            navigate('/employer/subscriptionplans');
          }
        });
      } else {
        Swal.fire('Error', response?.data?.error || response?.data?.message || 'Failed to save data', 'error');
      }
    } finally {
      isSaving.current = false;
    }
  };

  const handleBack = () => {
    navigate('/aboutyourself', { state: { userId, temporaryId } });
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <>
      <Navbar />
      <Container fluid className="job-form py-4" style={{ marginTop: '70px' }}>
        <div className="form-header text-center">
          <h1 className="d-flex align-items-center justify-content-center">
            <FaFileAlt className="me-2" style={{ fontSize: '60px' }} />
            Job Description
          </h1>
        </div>

        <div className="job-form-section p-4 bg-white">
          <Form>
            <Form.Group className="mb-4">
              <h4 className="d-flex align-items-center">
                <span className="fw-bold" style={{ color: 'black', marginTop: '30px' }}>
                  Job Title<span className="text-danger">*</span>
                </span>
              </h4>

              <div className="mt-3">
                {/* Container for both dropdowns in a single row */}
                <div className="d-flex flex-wrap gap-3 mb-3">
                  {/* First Dropdown - Country with "Family Looking For" */}
                  <div style={{ flex: '1 1 300px' }}>
                    <Dropdown
                      show={showFirstDropdown}
                      onToggle={(isOpen) => setShowFirstDropdown(isOpen)}
                    >
                      <Dropdown.Toggle
                        variant="light"
                        className="w-100 d-flex justify-content-between align-items-center text-start custom-dropdown-toggle"
                        style={{
                          padding: '12px',
                          border: '1px solid #ced4da',
                          backgroundColor: '#f8f9fa'
                        }}
                      >
                        {formData.job_title || "Select your nationality*"}
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="w-100" style={{ overflowY: 'hidden' }}>
                        <div className="px-3 py-2">
                          <Form.Control
                            type="text"
                            placeholder="Search country..."
                            value={firstDropdownSearch}
                            onChange={(e) => setFirstDropdownSearch(e.target.value)}
                            onClick={(e) => e.stopPropagation()}
                            autoFocus
                          />
                        </div>
                        <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
                          {filteredFirstOptions.map((option, index) => (
                            <Dropdown.Item
                              key={index}
                              onClick={() => handleSelectFirstDropdown(option)}
                              active={formData.job_title === option}
                            >
                              {option}
                            </Dropdown.Item>
                          ))}
                        </div>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>

                  {/* Second Dropdown - Job Categories */}
                  <div style={{ flex: '1 1 300px' }}>
                    <Dropdown
                      show={showSecondDropdown}
                      onToggle={(isOpen) => setShowSecondDropdown(isOpen)}
                    >
                      <Dropdown.Toggle
                        variant="light"
                        className="w-100 d-flex justify-content-between align-items-center text-start custom-dropdown-toggle"
                        style={{
                          padding: '12px',
                          border: '1px solid #ced4da',
                          backgroundColor: '#f8f9fa'
                        }}
                      >
                        {formData.job_category || "Select category"}
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="w-100" style={{ overflowY: 'hidden' }}>
                        <div className="px-3 py-2">
                          <Form.Control
                            type="text"
                            placeholder="Search job category..."
                            value={secondDropdownSearch}
                            onChange={(e) => setSecondDropdownSearch(e.target.value)}
                            onClick={(e) => e.stopPropagation()}
                            autoFocus
                          />
                        </div>
                        <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
                          {filteredSecondOptions.length > 0 ? (
                            filteredSecondOptions.map((option, index) => (
                              <Dropdown.Item
                                key={index}
                                onClick={() => handleSelectSecondDropdown(option)}
                                active={formData.job_category === option}
                              >
                                {option}
                              </Dropdown.Item>
                            ))
                          ) : (
                            <Dropdown.Item disabled>No matches found</Dropdown.Item>
                          )}
                        </div>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>

                {/* Display selected job title */}
                <div className="mt-3 p-3 bg-light rounded">
                  <div className="text-muted small mb-1">Selected Job Title:</div>
                  <div className="fw-bold" style={{ fontSize: '18px', color: '#0d6efd' }}>
                    {getFullJobTitle() || 'No selection made'}
                  </div>
                </div>

                <div className="d-flex justify-content-between mt-2" style={{ fontSize: '16px' }}>
                  <div>
                    {/* Job Title must have at least 20 characters */}
                  </div>
                  {/* <div className={`character-count ${getCharacterCount() < 20 ? 'text-danger' : 'text-success'}`}>
                    {getCharacterCount()}/40 characters
                  </div> */}
                </div>
              </div>
            </Form.Group>
            <Form.Group className="mb-4">
              <h4 className="d-flex align-items-center">
                <span className="fw-bold" style={{ color: 'black', marginTop: '0px' }}>
                  Job Description<span className="text-danger">*</span>
                </span>
              </h4>
              <div className="mb-3" style={{ fontSize: '16px' }}>
                Provide job details for candidates
              </div>

              <div className="job-description-editor border p-3 rounded bg-light">
                <div className="toolbar d-flex mb-3 gap-2 flex-wrap align-items-center justify-content-between">
                  <div className="d-flex gap-2 flex-wrap">
                    <Button variant="light" size="sm" className="fw-bold border" onClick={() => applyFormat('bold')} title="Bold">
                      <FaBold />
                    </Button>
                    <Button variant="light" size="sm" className="fst-italic border" onClick={() => applyFormat('italic')} title="Italic">
                      <FaItalic />
                    </Button>
                    <Button variant="light" size="sm" className="border" onClick={() => applyFormat('underline')} title="Underline">
                      U
                    </Button>
                    <Button variant="light" size="sm" className="border" onClick={() => applyFormat('insertUnorderedList')} title="Bullet List">
                      <FaListUl />
                    </Button>
                    <Button variant="light" size="sm" className="border" onClick={() => applyFormat('insertOrderedList')} title="Numbered List">
                      <FaListOl />
                    </Button>
                    <Button variant="light" size="sm" className="border" onClick={() => applyFormat('subscript')} title="Subscript">
                      <FaSubscript />
                    </Button>
                    <Button variant="light" size="sm" className="border" onClick={() => applyFormat('superscript')} title="Superscript">
                      <FaSuperscript />
                    </Button>
                  </div>
                  <div>
                    <Button
                      variant="primary"
                      size="sm"
                      className="d-flex align-items-center gap-1"
                      onClick={handleChangeDescription}
                      disabled={isGenerating || !profileData}
                      title="Generate a different description style"
                      style={{ whiteSpace: 'nowrap' }}
                    >
                      <FaSyncAlt className={isGenerating ? 'spin-icon' : ''} />
                      <span>Change Description</span>
                    </Button>
                  </div>
                </div>
                <div
                  ref={editorRef}
                  contentEditable
                  className="custom-textarea p-2"
                  style={{
                    minHeight: '200px',
                    fontSize: '16px',
                    lineHeight: '1.5',
                    backgroundColor: 'white',
                    outline: 'none'
                  }}
                  onInput={handleEditorInput}
                  onKeyDown={saveCursorPosition}
                  onMouseUp={saveCursorPosition}
                  suppressContentEditableWarning={true}
                />
              </div>
              <div className="d-flex justify-content-between mt-1">
                <div>Min 20, max 60 words required</div>
                <div className={`${wordCount < 20 || wordCount > 60 ? 'text-danger' : 'text-success'}`}>
                  {wordCount} / 60 words
                </div>
              </div>

            </Form.Group>
          </Form>
        </div>

        <div className="additional-section mb-4" style={{ marginTop: '20px' }}>
          <div
            className="d-flex justify-content-between gap-2"
            style={{ width: "100%" }}
          >
            <Button className="nav-btn" style={{ flex: 1 }} variant="secondary" onClick={handleBack}>
              Back
            </Button>

            <Button className="nav-btn" style={{ flex: 1 }} variant="secondary" onClick={() => handleSubmit('next')}>
              Next
            </Button>
          </div>
        </div>
      </Container>
    </>
  );
};

export default JobDescriptionForm;



